export default {"src":"/_next/static/media/tick.9b005449.svg","height":16,"width":21,"blurWidth":0,"blurHeight":0};